const methodMap = {
  assessment: require("library/show/components/content/assessment/manage/methods"),
  audio: require("library/show/components/content/audio/manage/methods"),
  completion: require("library/show/components/content/completion/manage/methods"),
  event: require("library/show/components/content/event/manage/methods"),
  reading: require("library/show/components/content/reading/manage/methods"),
  submission: require("library/show/components/content/submission/manage/methods"),
  video: require("library/show/components/content/video/manage/methods")
}

const getContentManageMethods = function (contentType, activeMethod) {
  let methods = methodMap[contentType.toLowerCase()]

  if (methods == null) {
    methods = {}
  }

  if (activeMethod) {
    return {
      // NOTE: active method must be first as it may be "blocks"
      [activeMethod]: methods[activeMethod],
      blocks: require("library/show/components/content/blocks/manage/methods")
        .blocks
    }
  }

  return methods
}

export { getContentManageMethods }
